import axiosClient from './apiClient';

export const getBestSellerById = (id: string, data: any) => {
  return axiosClient.post(`/api/v2/product/bestseller/${id}`, data, { headers: { 'subpath': data.subpath } });
};

export const getScreensaver = (subpath?: string | null) => {
  const headers: Record<string, string> = { Accept: 'application/json' };
  if (subpath) headers['subpath'] = subpath;
  return axiosClient.get('/api/admin/v1/getScreensaver', { headers });
};
